import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';
import { useCreateMutation, useIndexQuery } from 'api';
import { BasicModal } from 'components/modals/BasicModal';
import { type FC, useState } from 'react';

export const KonnectOnboardingReminderModal: FC = () => {
  const navigate = useNavigate();

  const [isDismissed, setIsDismissed] = useState(false);

  const konnectConfigQuery = useIndexQuery('pharmacies/trades/konnect/config/mine', {});

  const snoozeMutation = useCreateMutation(
    'pharmacies/role/global_settings/_snooze_konnect_onboarding'
  );

  const isOpen = !isDismissed && !!konnectConfigQuery.data?.display_onboarding_reminder;

  if (!isOpen) return null;

  const snooze = () => snoozeMutation.mutateAsync({});

  const handleConfigure = () => {
    snooze().then(() => {
      setIsDismissed(true);
      navigate({ to: '/pharmacy/faks_konnect' });
    });
  };

  const handleSnooze = () => {
    snooze().then(() => setIsDismissed(true));
  };

  return (
    <BasicModal
      open
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        },
      }}
      title={t`Faks Konnect Premium`}
    >
      <Stack gap={3} alignItems="center">
        <Stack gap={2}>
          <Typography>
            <Trans>
              Vous bénéficiez de notre offre Premium : <strong>Faks Konnect</strong> ! Certaines
              fonctionnalités restent à paramétrer pour automatiser totalement vos opérations
              commerciales.
            </Trans>
          </Typography>

          <Typography>
            <Trans>Pour rappel, Faks Konnect en chiffres :</Trans>
          </Typography>

          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            <Typography component="li">
              <Trans>
                un suivi automatisé des compensations qui vous permet de récupérer entre{' '}
                <strong>3000€ et 12000€ par an</strong>
              </Trans>
            </Typography>
            <Typography component="li">
              <Trans>
                jusqu’à <strong>5 jours par mois gagnés</strong> sur la mise en place et le
                paramétrage de vos opérations
              </Trans>
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ width: '100%' }}>
          <Button onClick={handleSnooze} variant="outlined" disabled={snoozeMutation.isPending}>
            {t`Me le rappeler plus tard`}
          </Button>
          <Button onClick={handleConfigure} variant="contained" disabled={snoozeMutation.isPending}>
            {t`Paramétrer Konnect`}
          </Button>
        </Stack>
      </Stack>
    </BasicModal>
  );
};
